var accessibilityHelpers = {};
accessibilityHelpers.init = function() {
    // 1. Trap focus within the drawer when it's open
    var drawer = document.querySelector('#mega-nav');
    var firstFocusableElement = drawer.querySelector('.drawer-close.close-main-drawer');

    drawer.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' || e.keyCode === 9) {
            var focusableElements = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            var firstElement = focusableElements[0];
            var lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
            }
        }
    });

// Function to set initial focus when drawer opens
    function setInitialFocus() {
        setTimeout(function() {
            console.log(firstFocusableElement);
            firstFocusableElement.focus();
        }, 500);
    }

// Add event listener for menu opening
    var menuToggleButton = document.querySelector('#open-main-drawer');
    if (menuToggleButton) {
        menuToggleButton.addEventListener('click', setInitialFocus);
    }

// 2. Toggle accordion items with Enter key
    var accordionHeaders = document.querySelectorAll('.accordion-header'); // Assuming you have a selector for accordion headers

    for (var i = 0; i < accordionHeaders.length; i++) {
        accordionHeaders[i].addEventListener('keydown', function(e) {
            if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                e.preventDefault();
                var parentAccordion = findClosest(this, '.list-item.accordion');
                if (parentAccordion) {
                    parentAccordion.classList.toggle('open');
                }
            }
        });
    }

// Polyfill for Element.closest for IE11
    function findClosest(el, selector) {
        while (el) {
            if (el.matches(selector)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

// 3. Make child elements tabbable and functional
    var accordionBodies = document.querySelectorAll('.list-item-description.accordion-body');
    var drawerOnlyBody = document.querySelectorAll('.drawer-nested-only');

    function addEventsToMenuItems(selector) {
        for (var i = 0; i < selector.length; i++) {
            var body = selector[i];
            var childLinks = body.querySelectorAll('a, .list-item--text');
            for (var j = 0; j < childLinks.length; j++) {
                var link = childLinks[j];
                link.setAttribute('tabindex', '0');
                link.addEventListener('keydown', function(e) {
                    if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                        e.preventDefault();
                        if (this.getAttribute('href')) {
                            window.location.href = this.getAttribute('href');
                        } else {
                            // Trigger click event for non-anchor elements
                            this.click();
                        }
                    }
                });
            }
        }
    }
    function closest(element, selector) {
        while (element) {
            if (element.matches(selector)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }
    function drawerOnlyNavs() {
        var uniqueNavs = document.querySelectorAll('.list-item:not(.accordion) > .list-item--text.drawer-only');
        let currentOpenDrawer = null;

        for (var i = 0; i < uniqueNavs.length; i++) {
            var section = uniqueNavs[i];
            section.setAttribute('tabindex', '0');
            section.setAttribute('role', 'button');
            section.setAttribute('aria-expanded', 'false');
            section.addEventListener('keydown', function(e) {
                if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                    e.preventDefault();
                    toggleDrawerOnly(this);
                }
            });
        }

        function toggleDrawerOnly(section) {
            var isActive = section.classList.contains('active');
            var drawer = section.nextElementSibling;
            var megaNav = document.querySelector('#mega-nav');
            let allOpenDrawers;

            // If there's an open drawer and it's not the current one, close it
            if (currentOpenDrawer && currentOpenDrawer !== drawer) {
                closeDrawerOnly(currentOpenDrawer);
            }

            // Toggle active class and aria-expanded attribute
            section.classList.toggle('active');
            section.setAttribute('aria-expanded', !isActive);

            // Toggle drawer open class
            if (drawer && drawer.classList.contains('drawer-nested')) {
                drawer.classList.toggle('open');
                megaNav.classList.toggle('nested-drawer-active');
                // Close all open drawers when opening a new one - this happens with accordions that have drawers
                allOpenDrawers = document.querySelectorAll('.drawer.drawer-nested.open');
                if(allOpenDrawers && allOpenDrawers.length > 1){
                    megaNav.classList.toggle('nested-drawer-active');
                    allOpenDrawers[0].classList.toggle('open');
                }
                if (!isActive) {
                    currentOpenDrawer = drawer;
                } else {
                    currentOpenDrawer = null;
                }
            }
        }

        function closeDrawerOnly(drawer) {
            drawer.classList.remove('open');
            var section = drawer.previousElementSibling;
            if (section) {
                section.classList.remove('active');
                section.setAttribute('aria-expanded', 'false');
            }
            currentOpenDrawer = null;
        }

        // Close drawer when clicking outside
        document.addEventListener('click', function(event) {
            if (currentOpenDrawer && !currentOpenDrawer.contains(event.target) && !event.target.classList.contains('drawer-only')) {
                closeDrawerOnly(currentOpenDrawer);
            }
        });

        // Close drawer when pressing Enter or Space outside
        document.addEventListener('keydown', function(e) {
            if (currentOpenDrawer && ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32))) {
                var activeElement = document.activeElement;
                if (!currentOpenDrawer.contains(activeElement) && !activeElement.classList.contains('drawer-only')) {
                    closeDrawerOnly(currentOpenDrawer);
                }
            }
        });
    }
    // Function to handle close buttons inside nested drawers
    function handleNestedDrawerCloseButtons() {
        var nestedDrawers = document.querySelectorAll('.drawer.drawer-nested');
        var megaNav = document.querySelector('#mega-nav');

        for (var i = 0; i < nestedDrawers.length; i++) {
            (function(drawer) {
                var closeButton = drawer.querySelector('.drawer-close.close-main-drawer');
                var parentDrawer = drawer;

                if (closeButton) {
                    closeButton.addEventListener('keydown', function(e) {
                        if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                            e.preventDefault();
                            var closestDrawer = findClosest(this, '.drawer.drawer-nested');
                            if (closestDrawer) {
                                closestDrawer.classList.remove('open');
                            }
                            this.click(); // Simulate a click on the button
                        }
                    });

                    // Ensure the button is focusable
                    if (!closeButton.getAttribute('tabindex')) {
                        closeButton.setAttribute('tabindex', '0');
                    }

                    // Add aria-label if not present
                    if (!closeButton.getAttribute('aria-label')) {
                        closeButton.setAttribute('aria-label', 'Close drawer');
                    }
                }
            })(nestedDrawers[i]);
        }
    }

    //Add events
    addEventsToMenuItems(accordionBodies);
    addEventsToMenuItems(drawerOnlyBody);

    // Call the function to initialize the nested drawer close buttons
    handleNestedDrawerCloseButtons();

    // Call the function to initialize the special sections
    drawerOnlyNavs();
}

//Don't fire this until we have navigation
window.domUtils.waitForElement('.drawer-body', accessibilityHelpers.init);
